module.exports = __webpack_public_path__ + "img/EUR.9be17308.png";